import React from 'react'

import { useContactInfo } from '../hooks/useContactInfo'
import { Container } from '../components/Container'
import { Heading } from '../components/Heading'
import { LinkButton } from '../components/LinkButton'
import { Section } from '../components/Section'
import { parsePhone } from '../utils/phone'
import { IconEmail, IconPhone } from '../components/Icons'
import { useContactUsSection } from '../hooks/useContactUsSection'
import { GatsbyImage } from 'gatsby-plugin-image'
import { ContactForm } from '../components/ContactForm'

export const ContactUs = () => {
  const { basicContact } = useContactInfo()
  const { contactUsSection } = useContactUsSection()

  return (
    <Section className="bg-secondary-50">
      <Container>
        <div className="grid items-center gap-8">
          <div className="grid items-center gap-8 md:grid-cols-[auto,auto]">
            <div className="grid gap-8">
              <Heading as="h2">Pojďme to zaúčtovat!</Heading>

              <ol className="grid leading-9 list-decimal pl-6">
                <li>Zavoláme si spolu a probereme situaci.</li>
                <li>Potkáme se osobně u nás ve firmě a promluvíme si.</li>
                <li>Převedeme nebo založíme účetnictví.</li>
                <li>Budeme se o vás starat a vy budete v klidu podnikat.</li>
              </ol>

              <div className="grid gap-2 justify-items-start self-end">
                {basicContact?.phone && (
                  <LinkButton
                    className="button button--primary"
                    href={`tel:+420${parsePhone(contactUsSection.phone!)}`}
                  >
                    <IconPhone />
                    +420 {contactUsSection.phone}
                  </LinkButton>
                )}

                {basicContact?.email && (
                  <LinkButton
                    className="button button--primary"
                    href={`mailto:${basicContact.email}`}
                  >
                    <IconEmail />
                    {basicContact.email}
                  </LinkButton>
                )}
              </div>
            </div>

            <div className="grid">
              {contactUsSection && (
                <div className="grid gap-4 justify-center lg:grid-cols-[auto,auto] md:items-end md:justify-end">
                  {contactUsSection.photo &&
                    contactUsSection.photo.gatsbyImage && (
                      <GatsbyImage
                        className="rounded overflow-hidden max-w-full lg:order-1 mix-blend-darken"
                        image={contactUsSection.photo.gatsbyImage}
                        alt={contactUsSection.personName!}
                      />
                    )}

                  <div className="text-end lg:order-0 lg:mb-11">
                    {contactUsSection.personName && (
                      <p className="font-medium">
                        {contactUsSection.personName}
                      </p>
                    )}

                    {contactUsSection.position && (
                      <p>{contactUsSection.position}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="grid gap-8">
            <Heading as="h3" className="text-xl xl:text-4xl">
              Co pro vás můžeme udělat?
            </Heading>

            <ContactForm />
          </div>
        </div>
      </Container>
    </Section>
  )
}
